import { useAccountTypeBrowse } from "@features/tickets/shared/hooks/useAccountTypeBrowse";
import { INCOME_ACCOUNT_TYPE } from "./incomes.constants";

export function useIncomesBrowse() {
  return useAccountTypeBrowse({
    accountType: INCOME_ACCOUNT_TYPE,
  });
}
